export default "__VITE_ASSET__167d8b6c__"